import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import { BTInput } from "commonComponents/btWrappers/BTInput/BTInput";
import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

function columnTextInternal(props: IGridCellRendererParams) {
    return (
        <TextTruncate className={cn("ag-col-text", props.className)}>{props.value}</TextTruncate>
    );
}

function columnTextEditInternal(props: IGridCellRendererParams) {
    if (props.node.group) {
        return <>{props.value}</>;
    } else if (props.value) {
        return (
            <BTInput
                id={`ag-col-text-editor.${props.colDef!.field!}.${props.node.rowIndex!}`}
                data-testid="ag-col-text-editor"
                value={props.value || undefined}
                onChange={() => {}}
                onBlur={() => {}}
                className={cn("ag-col-text-editor", props.className)}
            />
        );
    }
    return null;
}

export const columnText = memo(columnTextInternal);
export const columnTextEdit = memo(columnTextEditInternal);
